import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FreeTrial } from '@app/Models/free-trial.model';
import { TrialLog } from '@app/Models/trial-log.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FreeTrialService {
    private apiUrl = '/api/trial';

    constructor(private http: HttpClient) { }

    getFreeTrial(tenantId: string): Observable<FreeTrial> {
        const url = `${this.apiUrl}/${tenantId}`;
        return this.http.get<FreeTrial>(url);
    }

    cancelTrial(tenantId: string, reason: string): Observable<FreeTrial> {
        const url = `${this.apiUrl}/${tenantId}/cancel`;
        const body = { reasonOfCancellation: reason };
        return this.http.post<FreeTrial>(url, body);
    }

    reactivateTrial(tenantId: string, reason: string): Observable<FreeTrial> {
        const url = `${this.apiUrl}/${tenantId}/reactivate`;
        const body = { reasonOfReactivation: reason };
        return this.http.post<FreeTrial>(url, body);
    }

    upgradeToPaidTenant(tenantId: string): Observable<void> {
        const url = `${this.apiUrl}/${tenantId}/upgrade-to-paid`;
        return this.http.post<void>(url, null);
    }

    extendTrial(tenantId: string, newExpiryDate: Date): Observable<FreeTrial> {
        const url = `${this.apiUrl}/${tenantId}/extend`;
        return this.http.post<FreeTrial>(url, newExpiryDate);
    }

    updateTrial(tenantId: string, newTrial: FreeTrial): Observable<FreeTrial> {
        const url = `${this.apiUrl}/${tenantId}/update`;
        return this.http.post<FreeTrial>(url, newTrial);
    }

    getTrialLogs(tenantId: string): Observable<TrialLog[]> {
        const url = `${this.apiUrl}/${tenantId}/logs`;
        return this.http.get<TrialLog[]>(url);
    }
}
